module.exports = __webpack_public_path__ + "img/img-89b172.png";